import { render } from "./BookingClient.vue?vue&type=template&id=78ef8a52&scoped=true"
import script from "./BookingClient.vue?vue&type=script&lang=js"
export * from "./BookingClient.vue?vue&type=script&lang=js"

import "./BookingClient.vue?vue&type=style&index=0&id=78ef8a52&scoped=true&lang=css"

import exportComponent from "C:\\mgtspl\\mgtspl\\MGTSPL_FE\\MGTSPL\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ef8a52"]])

export default __exports__